export default function getFullName(obj) {
  const { first_name, last_name } = obj;
  return `${first_name} ${last_name}`;
}

